/**
 * Mirrored from `cosmo-bud-portal-backend/src/modules/earnings/dto/earning.schemas.ts`.
 */
import { z } from 'zod';

export const EARNING_STATUSES = ['held', 'eligible', 'released'] as const;
export type EarningStatus = (typeof EARNING_STATUSES)[number];

export const PAYOUT_STATUSES = ['pending', 'approved', 'rejected'] as const;
export type PayoutStatus = (typeof PAYOUT_STATUSES)[number];

export const TutorEarningResponseSchema = z.object({
  id: z.string(),
  tutorId: z.string(),
  bookingId: z.string(),
  parentId: z.string(),
  grossMinor: z.number().int(),
  commissionMinor: z.number().int(),
  netMinor: z.number().int(),
  currency: z.string(),
  status: z.enum(EARNING_STATUSES),
  eligibleAt: z.string(),
  createdAt: z.string(),
});
export type TutorEarningResponse = z.infer<typeof TutorEarningResponseSchema>;

export const PayoutRecordResponseSchema = z.object({
  id: z.string(),
  tutorId: z.string(),
  earningIds: z.array(z.string()),
  totalNetMinor: z.number().int(),
  currency: z.string(),
  status: z.enum(PAYOUT_STATUSES),
  adminNotes: z.string().nullable(),
  resolvedAt: z.string().nullable(),
  createdAt: z.string(),
});
export type PayoutRecordResponse = z.infer<typeof PayoutRecordResponseSchema>;
